document.addEventListener("DOMContentLoaded", () => {
  const collectionHeroSwiper = new Swiper(".collection-hero-swiper", {
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
    pagination: {
      el: ".collection-hero-swiper-pagination",
      type: "custom",
      renderCustom: function (swiper, current, total) {
        return (
          '<span class="collection-hero-swiper-pagination-current">'+ String(current).padStart(2, '0') +'</span> <span class="collection-hero-swiper-pagination-total">/'+ String(total).padStart(2, '0') +'</span>'
        )
      },
    },
  });
  
  const textSliderSwiper = new Swiper(".text-slider-swiper", {
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      // prevEl: ".swiper-button-prev-custom",
    },
    pagination: {
      el: ".text-slider-swiper-pagination",
    },
    slidesPerView: 'auto',
    spaceBetween: 24,
  });
  
  const sizesSliderSwiper = new Swiper(".sizes-slider-swiper", {
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
  });

  const accordionHeaders = document.querySelectorAll("[data-accordion-header]");
  accordionHeaders.forEach((accordionHeader) => {
    let target = accordionHeader.parentElement.nextElementSibling;
    let closedIcon = accordionHeader.querySelector(
      "[data-accordion-icon-closed]"
    );
    let openedIcon = accordionHeader.querySelector(
      "[data-accordion-icon-opened]"
    );
    accordionHeader.onclick = () => {
      let expanded =
        accordionHeader.getAttribute("aria-expanded") === "true" || false;
      accordionHeader.setAttribute("aria-expanded", !expanded);
      target.hidden = expanded;
      closedIcon.toggleAttribute("hidden");
      openedIcon.toggleAttribute("hidden");
    };
  });
});
